import { render, staticRenderFns } from "./IsReceipt.vue?vue&type=template&id=af63195c&"
import script from "./IsReceipt.vue?vue&type=script&lang=js&"
export * from "./IsReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports